module.exports = __webpack_public_path__ + "img/成交确认.792e0fd5.png";